import resultsBox from "./components/resultsBox/resultsBox"
import widgetBox from "./components/widget/widgetBox"

export default {
    name: 'App',

    components: {
        resultsBox,
        widgetBox
    },

    setup() {
        
    },

    template: /*html*/`
        <div class="cfm_ec_widget_container">

            <widget-box></widget-box>

            <!-- <results-box></results-box> -->
        
        </div>
    `,
}